<template>
  <base-page-component>
    <b-row>
      <b-col offset-md="9" md="3" class="my-0">
        <b-input-group prepend="Usage in last">
          <b-form-select v-model="selectedUsageInterval" :options="selectedUsageIntervalOptions" class="" />
          <b-btn class="btn btn-success text-white ml-2 pull-right" @click="RefreshHeatmap">
            <i class="fa fa-refresh" title="Refresh"></i> <strong class="text-white">Refresh</strong>
          </b-btn>
        </b-input-group>
      </b-col>
    </b-row>
      <br />
      <b-row>
        <b-col md="12" class="my-0">

          <b-card no-body>
            <b-tabs card>
              <b-tab style="min-height: 95%; min-width: 100%;" title="Users Online Map" active>
                <b-row v-if="usersOnline_GotData">
                  <dx-vector-map id="usersOnlineMap"
                                 :bounds="usersOnline_bounds"
                                 :controlBar="usersOnline_controlBar"
                                 @tooltip-shown="usersOnline_onTooltipShown">
                    <dx-layer :data-source="usersOnline_mapsWorld"
                              :color-groups="usersOnline_colorGroups"
                              :palette="usersOnline_palette"
                              :customize="usersOnline_customizeLayer"
                              name="areas"
                              color-grouping-field="msisHeat">
                      <dx-label :enabled="true" data-field="postal" />
                    </dx-layer>
                    <!--<dx-title text="Marketscan Heat map">
              <dx-subtitle text="(by state)" />
            </dx-title>-->
                    <dx-legend :customize-text="usersOnline_customizeLegendText">
                      <dx-source layer="areas"
                                 grouping="color" />
                    </dx-legend>
                    <dx-tooltip :enabled="true" :customize-tooltip="usersOnline_customizeTooltip" />
                    <dx-export :enabled="false" />
                  </dx-vector-map>
                </b-row>
              </b-tab>

              <b-tab title="Users Online">
                <b-row>
                  <b-col md="7" class="my-0">
                    <b-form-group class="my-1">
                      <b-input-group>
                        <!--v-on:keyup.esc="ClearSearch"-->
                        <b-form-input @keydown.native="usersOnline_EscClearSearch" v-model="usersOnline_tbxFilter" id="tbxFilter" placeholder="Type to search by account name, number or IP" />
                        <b-input-group-append>
                          <b-btn class="btn btn-default text-white ml-2" @click="usersOnline_ClearSearch">
                            <i class="fa fa-eraser" title="ClearSearch"></i> <strong class="text-white">Clear Search</strong>
                          </b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="5" class="my-0">
                    <b-form-group class="my-1 pt-2 mx-5 float-right">
                      <b-input-group>
                        <b-input-group-append>
                          <div style="text-align:right; vertical-align:central">Showing {{ usersOnline_GetRowCount(usersOnline_Items) }} / {{ usersOnline_totalCount }} records</div>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Main table element -->
                <b-table id="tblStatuses" :items="usersOnline_FilteredRecords" hover striped bordered small :fields="usersOnline_fields" :current-page="usersOnline_currentPage" :per-page="usersOnline_perPage" :sort-compare="onSortChanged" show-empty>
                  <template slot="LastLoginTS" slot-scope="data">
                    {{data.item.LastLoginTS | formatDate}}
                  </template>
                  <template slot="SinceLastLoginTS" slot-scope="data">
                    {{data.item.LastLoginTS | formatDateToNow}}
                  </template>
                </b-table>
                <!-- NAV -->
                <nav>
                  <b-pagination :total-rows="usersOnline_GetRowCount(usersOnline_Items)" :per-page="usersOnline_perPage" v-model="usersOnline_currentPage" prev-text="Prev" next-text="Next" />
                </nav>
              </b-tab>

              <b-tab style="min-height: 95%; min-width: 100%;" title="mScan Usage Map">
                <b-row v-if="scanUsage_GotData">
                  <dx-vector-map id="scanUsageMap"
                                 :bounds="scanUsage_bounds"
                                 :controlBar="scanUsage_controlBar">
                    <!--@tooltip-shown="scanUsage_onTooltipShown"-->
                    <dx-layer :data-source="scanUsage_mapsWorld"
                              :color-groups="scanUsage_colorGroups"
                              :palette="scanUsage_palette"
                              :customize="scanUsage_customizeLayer"
                              name="areas"
                              color-grouping-field="scanUsage_msisHeat">
                      <dx-label :enabled="true" data-field="postal" />
                    </dx-layer>
                    <dx-legend :customize-text="scanUsage_customizeLegendText">
                      <dx-source layer="areas"
                                 grouping="color" />
                    </dx-legend>
                    <dx-tooltip :enabled="true" :customize-tooltip="scanUsage_customizeTooltip" />
                    <dx-export :enabled="false" />
                  </dx-vector-map>
                </b-row>
              </b-tab>

              <b-tab title="mScan Usage">
                <b-row>
                  <b-col md="7" class="my-0">
                    <b-form-group class="my-1">
                      <b-input-group>
                        <!--v-on:keyup.esc="ClearSearch"-->
                        <b-form-input @keydown.native="scanUsage_EscClearSearch" v-model="scanUsage_tbxFilter"
                                      placeholder="Type to search by account number, dealer name or id, partner name or state" />
                        <b-input-group-append>
                          <b-btn class="btn btn-default text-white ml-2" @click="scanUsage_ClearSearch">
                            <i class="fa fa-eraser" title="ClearSearch"></i> <strong class="text-white">Clear Search</strong>
                          </b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="5" class="my-0">
                    <b-form-group class="my-1 pt-2 mx-5 float-right">
                      <b-input-group>
                        <b-input-group-append>
                          <div style="text-align:right; vertical-align:central">
                            Total: {{ scanUsage_totalCount }} | Displayed: {{ scanUsage_GetRowCount(scanUsage_Items) }} | Scan Count sum: {{SumScanCount.toLocaleString('en-US', {minimumFractionDigits: 2})}}
                          </div>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Main table element -->
                <b-table id="tblStatuses" :items="scanUsage_FilteredRecords" hover striped bordered small :fields="scanUsage_fields" :current-page="scanUsage_currentPage" :per-page="scanUsage_perPage" :sort-compare="onSortChanged" show-empty>
                  <template slot="LastLoginTS" slot-scope="data">
                    {{data.item.LastLoginTS | formatDate}}
                  </template>
                  <template slot="SinceLastLoginTS" slot-scope="data">
                    {{data.item.LastLoginTS | formatDateToNow}}
                  </template>
                </b-table>
                <!-- NAV -->
                <nav>
                  <b-pagination :total-rows="scanUsage_GetRowCount(scanUsage_Items)" :per-page="scanUsage_perPage" v-model="scanUsage_currentPage" prev-text="Prev" next-text="Next" />
                </nav>
              </b-tab>

            </b-tabs>
          </b-card>

        </b-col>
      </b-row>

</base-page-component>
</template>

<style>
  #usersOnlineMap {
    /*height: 500px;
    width: 100%;*/
    height: 65vh;
    width: 82vw;

    display: block;
  }

  #scanUsageMap {
    height: 65vh;
    width: 82vw;

    /*height: 500px;
    width: 100%;*/
    display: block;
  }

  h4 {
    font-size: 14px;
    margin-bottom: 5px;
  }

  #heat_container {
    width: 400px;
    height: 200px;
    display: block;
  }
</style>

<script>
import axios from 'axios'
import moment from 'moment'
import { usa_map } from '@/assets/usa_map.js'
import { basePageMixin } from '@/mixins/basePageMixin'
import {
  DxVectorMap,
  DxExport,
  DxLabel,
  DxLayer,
  DxLegend,
  DxSource,
  DxSubtitle,
  DxTitle,
  DxTooltip
} from 'devextreme-vue/ui/vector-map'

import DxChart from 'devextreme/viz/chart'

const format = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0
}).format

export default {
  components: {
    DxVectorMap,
    DxExport,
    DxLabel,
    DxLayer,
    DxLegend,
    DxSource,
    DxSubtitle,
    DxTitle,
    DxTooltip
  },
  mixins: [basePageMixin],
  data () {
    let self = this

    let usersOnline_accNumber = localStorage.getItem('ADPDownloadTestvueFilter')
    if (usersOnline_accNumber === null || usersOnline_accNumber === 'null' || usersOnline_accNumber === 'undefined') {
      usersOnline_accNumber = undefined
    }

    let array = [{ value: 60, text: '1 hour' }]
    for (let i = 2; i < 13; i++) {
      array.push({ value: 60 * i, text: `${i} hours` })
    }

    return {
      selectedUsageInterval: 60,
      selectedUsageIntervalOptions: array,

      usersOnline_GrouppedData: [],
      usersOnline_UsersOnline: [],
      usersOnline_GotData: false,

      usersOnline_palette: ['#00e6e6', '#01F406', '#F1F400', '#FF8000', '#F40000'],
      usersOnline_colorGroups: [-1, 0, 5, 20, 40, 10000000],

      usersOnline_customizeLayer: function (elements) {
        elements.forEach(function (element) {
          let postal = element.attribute('postal')
          let msisHeatArr = self.usersOnline_GrouppedData.filter(r => r.Key === postal)
          let msisHeat = msisHeatArr.length > 0 ? parseInt(msisHeatArr[0].Value) : -1
          element.attribute('msisHeat', msisHeat)
        })
      },
      usersOnline_mapsWorld: usa_map,
      usersOnline_customizeLegendText: function (arg) {
        if (arg.start === -1) {
          return 'No data'
        }
        return `${format(arg.start)} to ${format(arg.end)}`
      },
      usersOnline_customizeTooltip: function (arg) {
        let stateName = `${arg.attribute('name')} (${arg.attribute('postal')}) `
        let node = `<div #gdp><h4>${stateName}</h4><div id='heat_container'></div></div>`
        return {
          html: node
        }
      },
      usersOnline_bounds: [-115, 53, -82, 20],
      usersOnline_controlBar: {
        enabled: true
      },

      usersOnline_Items: [],
      usersOnline_tbxFilter: undefined,
      usersOnline_fields: [
        { key: 'AccountNumber', label: 'Account #', sortable: true },
        { key: 'Name', label: 'Name', sortable: true },
        { key: 'LastLoginTS', label: 'Last Login', sortable: true },
        { key: 'SinceLastLoginTS', label: 'Last Login Was', sortable: false },
        { key: 'LastIP', label: 'Last IP', sortable: false }
      ],
      usersOnline_totalCount: 0,
      usersOnline_currentPage: 1,
      usersOnline_perPage: 15,

      scanUsage_GrouppedData: [],
      scanUsage_UsersOnline: [],
      scanUsage_GotData: false,

      scanUsage_palette: ['#00e6e6', '#01F406', '#F1F400', '#FF8000', '#F40000'],
      scanUsage_colorGroups: [-1, 0, 25, 100, 200, 10000000],

      scanUsage_customizeLayer: function (elements) {
        elements.forEach(function (element) {
          let postal = element.attribute('postal')
          let msisHeatArr = self.scanUsage_GrouppedData.filter(r => (r.key).toLowerCase() === (postal).toLowerCase())
          let msisHeat = msisHeatArr.length > 0 ? parseInt(msisHeatArr[0].data.scanCountSum) : -1
          // console.log(`postal: ${JSON.stringify(postal)} msisHeat: ${JSON.stringify(msisHeat)}`)
          element.attribute('scanUsage_msisHeat', msisHeat)
        })
      },
      scanUsage_mapsWorld: usa_map,
      scanUsage_customizeLegendText: function (arg) {
        if (arg.start === -1) {
          return 'No data'
        }
        return `${format(arg.start)} to ${format(arg.end)}`
      },
      scanUsage_customizeTooltip: function (arg) {
        let number = parseInt(arg.attribute('scanUsage_msisHeat'))
        if (number === -1) {
          number = 'no data'
        }
        let node = `<div><h4>${arg.attribute('name')} (${arg.attribute('postal')}) ${number}</h4></div>`
        return {
          html: node
        }
      },
      scanUsage_bounds: [-115, 53, -82, 20],
      scanUsage_controlBar: {
        enabled: true
      },

      scanUsage_Items: [],
      scanUsage_tbxFilter: undefined,
      scanUsage_fields: [
        { key: 'AccountNumber', label: 'Account #', sortable: true },
        { key: 'DealerID', label: 'Dealer Id', sortable: true },
        { key: 'DealerName', label: 'Dealer Name', sortable: true },
        { key: 'PartnerName', label: 'Partner Name', sortable: true },
        { key: 'State', label: 'State', sortable: true },
        { key: 'LastLoginTS', label: 'Last Login', sortable: true },
        { key: 'SinceLastLoginTS', label: 'Last Login Was', sortable: true },
        { key: 'ScanCount', label: 'Scan Count', sortable: true },
        { key: 'RebateRateCount', label: 'Rate Count', sortable: true },
        { key: 'RebateOnlyCount', label: 'Rebate Count', sortable: true }
      ],
      scanUsage_totalCount: 0,
      scanUsage_currentPage: 1,
      scanUsage_perPage: 15,

      onSortChanged (a, b, key) {
        if (['accountLastRun', 'EXPIRATION_DATE'].indexOf(key) !== -1) {
          var a1
          var b1
          switch (key) {
            case 'CREATED_TS':
            case 'accountLastRun':
              a1 = moment(a[key])
              b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            a1 = (a[key] + '')
            b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      }
    }
  },
  created () {
    let self = this
    self.toggleloader(false)

    self.LoadHeatmap(false)
  },
  methods: {
    RefreshHeatmap () {
      let self = this
      self.LoadHeatmap(true)
    },
    LoadHeatmap () {
      let self = this

      self.toggleloader(true)
      self.usersOnline_GotData = false
      self.scanUsage_GotData = false

      let requestArray = []
      requestArray.push(axios.post('/api/Heatmap/Load', {}))
      requestArray.push(axios.post('/api/Heatmap/LoadScanUsage', { interval: self.selectedUsageInterval}))

      axios.all(requestArray)
        .then(axios.spread(function (F1, F2) {
          // Both requests are now complete
          self.usersOnline_GrouppedData = F1.data.GrouppedData
          self.usersOnline_Items = F1.data.UsersOnline
          self.usersOnline_totalCount = self.usersOnline_Items.length
          self.usersOnline_GotData = true

          self.scanUsage_GrouppedData = F2.data.ScanUsageGrupped
          // console.log('self.scanUsage_GrouppedData: '+JSON.stringify(self.scanUsage_GrouppedData))
          self.scanUsage_Items = F2.data.ScanUsage
          self.scanUsage_totalCount = self.scanUsage_Items.length
          self.scanUsage_GotData = true
        }))
        .catch(error => {
          self.handleError(error)
        }).then(r => {
          self.toggleloader(false)
        })
    },
    sortByKey (array, key) {
      return array.sort(function (a, b) {
        var x = a[key]; var y = b[key]
        return ((x < y) ? -1 : ((x > y) ? 1 : 0))
      })
    },

    usersOnline_onTooltipShown (e) {
      // let name = e.target.attribute('name')
      let msisHeat = e.target.attribute('msisHeat')
      let current = e.target.attribute('postal')

      let self = this
      let container = document.getElementById('heat_container')
      let config = self.usersOnline_getConfig(current, msisHeat)
      if (config !== undefined) {
        new DxChart(container, config)
      } else {
        container.text = 'No data'
      }
    },
    usersOnline_getConfig (current, msisHeat) {
      let self = this

      let i, param

      param = -1
      let len = self.usersOnline_GrouppedData.length

      for (i = 0; i < len; i++) {
        if (self.usersOnline_GrouppedData[i].Key === current) {
          param = i
          break
        }
      }

      let newArr = []
      if (param === -1) {
        newArr.push({
          Key: current, Value: msisHeat }
        )
      } else {
        newArr.push(self.usersOnline_GrouppedData[param])
      }

      for (i = 1; i < 4; i++) {
        let lparam = param - i
        let rparam = param + i

        if (lparam < 0) {
          newArr.unshift(self.usersOnline_GrouppedData[len + lparam])
        } else {
          newArr.unshift(self.usersOnline_GrouppedData[lparam])
        }

        if (rparam > len) {
          newArr.push(self.usersOnline_GrouppedData[rparam - len])
        } else {
          newArr.push(self.usersOnline_GrouppedData[rparam])
        }
      }

      let cfg = {
        dataSource: newArr,
        commonSeriesSettings: {
          argumentField: 'Key',
          valueField: 'Value',
          type: 'bar',
          color: '#e7d19a'
        },
        customizePoint: function () {
          if (this.argument === current) {
            return { color: '#e7d19a', hoverStyle: { color: '#e7d19a' } }
          } else {
            if (this.value > self.GrouppedDataAvg) {
              return { color: '#ff7c7c', hoverStyle: { color: '#ff7c7c' } }
            } else if (this.value < self.GrouppedDataAvg) {
              return { color: '#8c8cff', hoverStyle: { color: '#8c8cff' } }
            }
          }
        },
        customizeLabel: function () {
          let newValue = this.value < 0 ? 0 : this.value
          let newValueText = newValue + ''

          if (this.argument === current) {
            return {
              visible: true,
              backgroundColor: '#e7d19a',
              customizeText: function () {
                return newValueText + ' ' + current
              }
            }
          } else {
            return {
              visible: true,
              backgroundColor: newValue > self.GrouppedDataAvg ? '#ff7c7c' : '#8c8cff',
              customizeText: function () {
                return newValueText + ' ' + this.argument
              }
            }
          }
        },
        'export': {
          enabled: false
        },
        valueAxis: {
          min: 0,
          max: self.GrouppedDataMax,
          constantLines: [{
            label: {
              text: 'Average'
            },
            width: 2,
            value: self.GrouppedDataAvg,
            color: '#8c8cff',
            dashStyle: 'dash'
          }, {
            label: {
              text: 'High'
            },
            width: 2,
            value: self.GrouppedDataMax,
            color: '#ff7c7c',
            dashStyle: 'dash'
          }]
        },
        series: [{}],
        legend: {
          visible: false
        }
      }
      return cfg
    },
    usersOnline_GetRowCount (items) {
      let self = this
      return self.usersOnline_FilteredRecords.length
    },
    usersOnline_ClearSearch () {
      let self = this
      self.usersOnline_tbxFilter = undefined
    },
    usersOnline_EscClearSearch (event) {
      let self = this
      if (event.key === 'Escape') {
        self.usersOnline_tbxFilter()
      }
    },

    scanUsage_onTooltipShown (e) {
      // let name = e.target.attribute('name')
      let msisHeat = e.target.attribute('msisHeat')
      let current = e.target.attribute('postal')

      let self = this
      let container = document.getElementById('heat_container')
      let config = self.scanUsage_getConfig(current, msisHeat)
      if (config !== undefined) {
        new DxChart(container, config)
      } else {
        container.text = 'No data'
      }
    },
    scanUsage_getConfig (current, msisHeat) {
      let self = this

      let i, param

      param = -1
      let len = self.scanUsage_GrouppedData.length

      for (i = 0; i < len; i++) {
        if (self.scanUsage_GrouppedData[i].Key === current) {
          param = i
          break
        }
      }

      let newArr = []
      if (param === -1) {
        newArr.push({
          Key: current, Value: msisHeat
        }
        )
      } else {
        newArr.push(self.scanUsage_GrouppedData[param])
      }

      for (i = 1; i < 4; i++) {
        let lparam = param - i
        let rparam = param + i

        if (lparam < 0) {
          newArr.unshift(self.scanUsage_GrouppedData[len + lparam])
        } else {
          newArr.unshift(self.scanUsage_GrouppedData[lparam])
        }

        if (rparam > len) {
          newArr.push(self.scanUsage_GrouppedData[rparam - len])
        } else {
          newArr.push(self.scanUsage_GrouppedData[rparam])
        }
      }

      let cfg = {
        dataSource: newArr,
        commonSeriesSettings: {
          argumentField: 'Key',
          valueField: 'Value',
          type: 'bar',
          color: '#e7d19a'
        },
        customizePoint: function () {
          if (this.argument === current) {
            return { color: '#e7d19a', hoverStyle: { color: '#e7d19a' } }
          } else {
            if (this.value > self.GrouppedDataAvg) {
              return { color: '#ff7c7c', hoverStyle: { color: '#ff7c7c' } }
            } else if (this.value < self.GrouppedDataAvg) {
              return { color: '#8c8cff', hoverStyle: { color: '#8c8cff' } }
            }
          }
        },
        customizeLabel: function () {
          let newValue = this.value < 0 ? 0 : this.value
          let newValueText = newValue + ''

          if (this.argument === current) {
            return {
              visible: true,
              backgroundColor: '#e7d19a',
              customizeText: function () {
                return newValueText + ' ' + current
              }
            }
          } else {
            return {
              visible: true,
              backgroundColor: newValue > self.GrouppedDataAvg ? '#ff7c7c' : '#8c8cff',
              customizeText: function () {
                return newValueText + ' ' + this.argument
              }
            }
          }
        },
        'export': {
          enabled: false
        },
        valueAxis: {
          min: 0,
          max: self.GrouppedDataMax,
          constantLines: [{
            label: {
              text: 'Average'
            },
            width: 2,
            value: self.GrouppedDataAvg,
            color: '#8c8cff',
            dashStyle: 'dash'
          }, {
            label: {
              text: 'High'
            },
            width: 2,
            value: self.GrouppedDataMax,
            color: '#ff7c7c',
            dashStyle: 'dash'
          }]
        },
        series: [{}],
        legend: {
          visible: false
        }
      }
      return cfg
    },
    scanUsage_GetRowCount (items) {
      let self = this
      return self.scanUsage_FilteredRecords.length
    },
    scanUsage_ClearSearch () {
      let self = this
      self.scanUsage_tbxFilter = undefined
    },
    scanUsage_EscClearSearch (event) {
      let self = this
      if (event.key === 'Escape') {
        self.scanUsage_ClearSearch()
      }
    }

  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatDateToNow: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm')
        return localTime.toNow(true) + ' ago'
      }
      return ''
    }
  },
  computed: {
    GrouppedDataMin: function () {
      return 0
    },
    GrouppedDataMax: function () {
      let self = this
      let i = 0, max = 0
      let len = self.usersOnline_GrouppedData.length

      for (i = 0; i < len; i++) {
        if (self.usersOnline_GrouppedData[i].Value > max) {
          max = self.usersOnline_GrouppedData[i].Value
        }
      }
      return max
    },
    GrouppedDataAvg: function () {
      let self = this
      var sum = 0
      for (var i = 0; i < self.usersOnline_GrouppedData.length; i++) {
        sum += parseInt(self.usersOnline_GrouppedData[i].Value, 10) // don't forget to add the base
      }
      var avg = sum / self.usersOnline_GrouppedData.length
      return avg
    },
    usersOnline_FilteredRecords: function () {
      let self = this

      if (self.usersOnline_Items === undefined || self.usersOnline_Items === null) {
        return []
      } else {
        if (self.usersOnline_tbxFilter !== undefined && self.usersOnline_tbxFilter !== null && self.usersOnline_tbxFilter.length > 0) {
          let lk = self.usersOnline_tbxFilter.toLowerCase()

          return self.usersOnline_Items.filter(u => (u.AccountNumber + '').toLowerCase().includes(lk) ||
            (u.Name + '').toLowerCase().includes(lk) ||
            (u.LastIP + '').toLowerCase().includes(lk)
          )
        } else {
          return self.usersOnline_Items
        }
      }
    },
    scanUsage_FilteredRecords: function () {
      let self = this

      if (self.scanUsage_Items === undefined || self.scanUsage_Items === null) {
        return []
      } else {
        if (self.scanUsage_tbxFilter !== undefined && self.scanUsage_tbxFilter !== null && self.scanUsage_tbxFilter.length > 0) {
          let lk = self.scanUsage_tbxFilter.toLowerCase()

          return self.scanUsage_Items.filter(u =>
            (u.AccountNumber + '').toLowerCase().includes(lk) ||
            (u.DealerID + '').toLowerCase().includes(lk) ||
            (u.DealerName + '').toLowerCase().includes(lk) ||
            (u.PartnerName + '').toLowerCase().includes(lk) ||
            (u.State + '').toLowerCase().includes(lk)
          )
        } else {
          return self.scanUsage_Items
        }
      }
    },
    SumScanCount: function () {
      let self = this
      let scan_count = 0

      if (self.scanUsage_FilteredRecords === undefined || self.scanUsage_FilteredRecords === null) {
        return scan_count
      } else {
        let count = self.scanUsage_FilteredRecords.length

        for (let j = 0; j < count; j++) {
          let cc = parseInt(self.scanUsage_FilteredRecords[j].ScanCount)
          scan_count = scan_count + cc
        }
      }
      return scan_count
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Heatmap.vue